import {
	Component,
	EventEmitter,
	HostListener,
	Input,
	OnInit,
	Output,
	inject,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LanguagesService } from "@sportyano/core/services/language services/languages.service";
import { PaginatorModule } from "primeng/paginator";

@Component({
	selector: "paggination",
	templateUrl: "./paggination.component.html",
	styleUrl: "./paggination.component.scss",
	standalone: true,
	imports: [PaginatorModule],
})
export class PaginationComponent implements OnInit {

	//INJECT
	private _languageService = inject(LanguagesService);
	private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);
	//PUBLIC
	public currentLang: string;
	public first: number = 0;
	public pageLinkSize:number = 5;
	//OUTPUT
	private _page: number | undefined;
	private _rows: number = 12;

	@Output() pageChanged: EventEmitter<any> = new EventEmitter<any>();

	@Input() set rows(val: number) {
		this._rows = val || 12;
		if (this._page && this._page > 0) {
			this.first = (this._page - 1) * this._rows;
		}
	}
	get rows(): number {
		return this._rows;
	}

	@Input() totalRecords: number | undefined = 0;

	@Input() set page(val: number | undefined) {
		if (val !== undefined && val !== null && val > 0) {
			this._page = val;
			this.first = (val - 1) * (this.rows || 12);
		}
	}
	get page(): number | undefined {
		return this._page;
	}

	ngOnInit(): void {
		this.pageLinkSize = window.innerWidth < 640 ? 3 : 5;
		this._languageService.language$.subscribe({
			next: (res) => {
				this.currentLang = res;
			},
		});
		// activate current page based on query params
		this._listenToCurrentPage();
	}

	@HostListener("window:resize")
	onResize() {
		this.pageLinkSize = window.innerWidth < 640 ? 3 : 5; // Adjust for small screens
	}

	private _listenToCurrentPage(): void {
		this._activatedRoute.queryParams.subscribe((params) => {
			if (params["page"] && this._page === undefined) {
				const page = Number(params["page"]);
				if (!isNaN(page) && page > 0) {
					this.first = (page - 1) * this.rows;
				}
			}
		});
	}


	public onPageChange(e: any) {
		this.first = e.first;
		this._page = e.page + 1;
		this.pageChanged.emit({ pageIndex: e.page + 1, pageSize: e.rows });
	}
}
